import styled from "styled-components";

export const FooterTwoDesktopCont = styled.div`
  .contactUsIcon {
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
      display: none;
    }
    width: 45px;
    height: 45px;
    box-shadow: 0 4px 11px rgba(0, 0, 0, 0.07);
  }
`;